<div class="container">
  <div class="container__middle empty-setup" *ngIf="!(action.attr && action.value && action.type); else setupComplete">
    <button (click)="open.emit(index)" mat-flat-button><mat-icon>settings</mat-icon>&nbsp;Setup the Action</button>
  </div>
  <ng-template #setupComplete>
    <div class="container__top">
      <span><mat-icon svgIcon="heroicons_outline:lightning-bolt"></mat-icon>&nbsp;Action</span>
      <mat-icon #origin (click)="overlayHelper.open()" class="container__top__setup-button"
        >keyboard_arrow_down</mat-icon
      >
      <app-overlay-helper class="display-none" #overlayHelper [overlayOrigin]="origin" [position]="position">
        <div class="options-panel">
          <p>Options</p>
          <p (click)="openSetup(index)"><mat-icon>edit</mat-icon>&nbsp;Edit</p>
        </div>
      </app-overlay-helper>
    </div>
    <div class="container__middle">
      <div>
        <ng-container *ngIf="action.type === ActionType.SetAttribute">
          The <strong>{{ automation.target_model | relatedToTypeTitle: [] }}</strong> will have the attribute
          <strong>{{ action.attr | fieldNameToLabel: automation.target_model }}</strong> set to
          <strong>{{ action.value | readableField: {}:getField(action.attr):formData.options }}</strong>
        </ng-container>
        <ng-container *ngIf="action.type === ActionType.CreateUnderwritingModel">
          <ng-container *ngIf="eligibleFiles$ | async | filterBy: ['id']:action.value as files">
            <ng-container *ngIf="files?.length">
              <p class="file-text">
                File <strong>{{ files[0].name }}</strong> will be used to automatically create an underwriting model.
              </p>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>
